import React, { useState, useEffect } from "react";

const TabsClassic = ({tabs = [], idTab, initialState = 1, stateTab}) => {

    const [toggleState, setToggleState] = useState(initialState);

    useEffect(() => {
        if(idTab != undefined) setToggleState(idTab)
    }, [idTab])

    const toggleTab = (index) => setToggleState(index);

    return (
        <div className="classicTabs">
            <div className="bloc-tabs">
                {tabs.map((item) => (
                    <button
                        key={`tab${item.id}`}
                        className={toggleState === item.id ? "tabs active-tabs" : "tabs"}
                        onClick={() => {
                            toggleTab(item.id)
                            if(stateTab != undefined){
                                stateTab(item.id)
                            }
                        }}
                    >
                        {item.label}
                    </button>
                ))}
            </div>

            <div className="content-tabs">
                {tabs.map((item) => (
                    <div
                        key={`content${item.id}`}
                        className={toggleState === item.id ? "content  active-content" : "content"}
                    >
                        {item.content}
                    </div>
                ))}
            </div>
        </div>
    );
}

 export default TabsClassic;
